const ns_jump_link_nav = {
  navClass: '.jump-link-navigation__nav',

  navActiveClass: 'jump-link-navigation__nav-item--active',

  navItemsEl: document.querySelectorAll('.jump-link-navigation__nav-list-item'),

  mobileSliderTrackEl: document.querySelector(
    '.jump-link-navigation__nav-container--mobile .jump-link-navigation__nav-list',
  ),

  mobileNavEl: document.querySelector(
    '.jump-link-navigation__nav-container--mobile',
  ),

  sectionsEl: '[data-jump-link-anchor]',

  setActiveNavItem() {
    let scrollY = window.scrollY;

    document
      .querySelectorAll(ns_jump_link_nav.sectionsEl)
      .forEach((current) => {
        if (current.closest('section') !== null) {
          const sectionHeight = current.closest('section').offsetHeight;
          const sectionTop =
            current.closest('section').getBoundingClientRect().top +
            window.pageYOffset -
            180;
          const sectionId = current.getAttribute('id');

          if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
            document
              .querySelectorAll(
                `${ns_jump_link_nav.navClass} a[href*='${sectionId}']`,
              )
              .forEach((item) => {
                const index = item.getAttribute('data-index');

                // Remove other 'active' classes
                Array.from(item.parentNode.parentNode.children).forEach(
                  (item) => {
                    item.classList.remove(ns_jump_link_nav.navActiveClass);
                  },
                );

                // Assign new 'active' class
                item.parentElement.classList.add(
                  ns_jump_link_nav.navActiveClass,
                );

                // move the slider to current slide
                if (index) {
                  ns_jump_link_nav.mobileInstance.go(`=${index}`);
                }
              });
          }
        }
      });
  },

  createMobileSlider() {
    return new Glide(this.mobileNavEl, {
      type: 'slider',
      breakpoints: {
        0: {
          perView: 1,
          peek: 0,
          focusAt: 0,
          rewind: false,
        },
        400: {
          perView: 2,
          peek: 0,
          focusAt: 0,
          rewind: false,
        },
        500: {
          perView: 3,
          peek: 0,
          focusAt: 0,
          rewind: false,
        },
        700: {
          perView: 4,
          peek: 0,
          focusAt: 0,
          rewind: false,
        },
        800: {
          perView: 5,
          peek: 0,
          focusAt: 0,
          rewind: false,
        },
      },
      classes: {
        slider: 'jump-link-navigation--slider',
        carousel: 'jump-link-navigation--carousel',
        swipeable: 'jump-link-navigation--swipeable',
        dragging: 'jump-link-navigation--dragging',
        cloneSlide: 'jump-link-navigation__slide--clone',
        activeNav: 'jump-link-navigation__bullet--active',
        activeSlide: 'jump-link-navigation__slide--active',
        disabledArrow: 'jump-link-navigation__arrow--disabled',
      },
    });
  },

  mobileInstance: this.createMobileSlider,
};

window.addEventListener('scroll', ns_jump_link_nav.setActiveNavItem);

document.addEventListener('DOMContentLoaded', () => {
  ns_jump_link_nav.mobileInstance = ns_jump_link_nav.createMobileSlider();
  ns_jump_link_nav.mobileInstance.mount();
});
